import React, { useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { navigateToSection, parseHashSectionHref } from "../utils/hashSectionNav";

const ABOUT_LINKS = [
  { hrefKey: "link1", titleKey: "title1", route: null },
  { hrefKey: "link2", titleKey: "title2", route: "about.link2" },
  { hrefKey: "link3", titleKey: "title3", route: "about.link3" },
];

const PRODUCT_PATHS = {
  link1: "/account",
  link2: "/forujob",
  link3: "/foru",
  link4: "/contratoPF",
  link5: "/contratoPJ",
  link6: "/garantias",
};

const LGPD_PATHS = {
  link1: "/ciber-security",
  link2: "/dados-security",
  link3: "/uses-security",
  link4: "/ouvidoria",
  link5: "/cancelamento-de-conta",
};

export const Contact = (props) => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const location = useLocation();

  const onFooterAnchor = (e, href) => {
    const id = parseHashSectionHref(href);
    if (!id) return;
    e.preventDefault();
    navigateToSection(navigate, location, id);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: "0px", threshold: 0 }
    );

    const elements = document.querySelectorAll("#contact .reveal");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const nameBank2 = props.data ? props.data.nameBank2 : t("footer.bankUndefined");

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-12">
            <div className="row">
              <div className="section-title reveal"></div>
              <div className="row">
                <div className="col-md-3 col-xs-12 reveal">
                  <h5>{nameBank2}</h5>
                  {props.data?.line1?.cnpj ? (
                    <div className="contact-item">
                      <p>
                        {t("footer.cnpjPrefix")} {props.data.line1.cnpj}
                      </p>
                    </div>
                  ) : null}
                  {props.data?.line1?.address || props.data?.line1?.bairro ? (
                    <div className="contact-item">
                      {props.data.line1.address ? <p>{props.data.line1.address}</p> : null}
                      {props.data.line1.bairro ? <p>{props.data.line1.bairro}</p> : null}
                    </div>
                  ) : null}
                  {props.data?.line1?.city ? (
                    <div className="contact-item">
                      <p>{props.data.line1.city}</p>
                    </div>
                  ) : null}
                  {props.data?.line1?.cep ? (
                    <div className="contact-item">
                      <p>
                        {t("footer.cepPrefix")} {props.data.line1.cep}
                      </p>
                    </div>
                  ) : null}
                </div>

                <div className="col-md-2 col-xs-12 reveal">
                  <h5>{t("footer.whoWeAre")}</h5>
                  <div className="contact-item">
                    <a
                      href={props.data ? props.data.about.link1 : "/"}
                      onClick={(e) =>
                        onFooterAnchor(e, props.data ? props.data.about.link1 : "")
                      }
                    >
                      {t(`footer.aboutLinks.${ABOUT_LINKS[0].titleKey}`)}
                    </a>
                  </div>
                  <div className="contact-item">
                    <Link to="/workforus">{t("footer.aboutLinks.title2")}</Link>
                  </div>
                  <div className="contact-item">
                    <Link to="/message">{t("footer.aboutLinks.title3")}</Link>
                  </div>
                </div>

                <div className="col-md-2 col-xs-12 reveal">
                  <h5>{t("footer.productsColumn")}</h5>
                  {Object.keys(PRODUCT_PATHS).map((linkKey) => {
                    const titleKey = linkKey.replace("link", "title");
                    return (
                      <div key={linkKey} className="contact-item">
                        <a href={PRODUCT_PATHS[linkKey]}>
                          {t(`footer.productLinks.${titleKey}`)}
                        </a>
                      </div>
                    );
                  })}
                </div>

                <div className="col-md-2 col-xs-12 reveal">
                  <h5>{t("footer.lgpdColumn")}</h5>
                  {Object.keys(LGPD_PATHS).map((linkKey) => {
                    const titleKey = linkKey.replace("link", "title");
                    return (
                      <div key={linkKey} className="contact-item">
                        <a href={LGPD_PATHS[linkKey]}>
                          {t(`footer.lgpdLinks.${titleKey}`)}
                        </a>
                      </div>
                    );
                  })}
                </div>

                <div className="col-md-3 col-xs-12 reveal">
                  <h5>{t("footer.contactUs")}</h5>
                  <div className="contact-item">
                    <p>
                      <i className="fa fa-envelope"></i>
                      {props.data ? props.data.email : t("footer.loading")}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-12 reveal">
                <div className="row social">
                  <ul>
                    <li>
                      <a href={props.data ? props.data.facebook : "/"}>
                        <i className="fa fa-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href={props.data ? props.data.linkedin : "/"}>
                        <i className="fa fa-linkedin"></i>
                      </a>
                    </li>
                    <li>
                      <a href={props.data ? props.data.instagram : "/"}>
                        <i className="fa fa-instagram"></i>
                      </a>
                    </li>
                    <li>
                      <a href={props.data ? props.data.whatsapp : "/"}>
                        <i className="fa fa-whatsapp"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="footer">
        <div className="container text-center">
          <p>{t("footer.copyright", { nameBank2 })}</p>
          {props.data?.line1?.cnpj ? <p>{props.data.line1.cnpj}</p> : null}
        </div>
      </div>
    </div>
  );
};
